<mat-form-field
  class="lib-input coin-form-field-outline coin-form-field-outline--{{ matFormFieldClass() }} no-margin"
  matTooltipClass="error-tooltip"
  appearance="outline"
  floatLabel="always"
  [matTooltip]="errorTooltip()"
  [matTooltipDisabled]="!touched()">
  @if (label()) {
    <mat-label>
      {{ label() }}
      @if (required()) {
        *
      }
    </mat-label>
  }
  <input
    #numberInput
    #matInput="matInput"
    type="number"
    matInput
    autocomplete="off"
    [placeholder]="placeholder()"
    [attr.step]="step()"
    [attr.min]="min()"
    [attr.max]="max()"
    [class.hide-input-arrows]="hideInputArrows()"
    [ngModel]="viewValue()"
    [disabled]="disabled()"
    (ngModelChange)="onInputChange($event)"
    (blur)="onInputBlur(matInput.value)" />
  @if (icon()) {
    <span class="material-icons icon">{{ icon() }}</span>
  }
</mat-form-field>
